import type { LayoutResponse } from '@portal/platform/configuration';

/** Every route the backend navigation offers this app, children and header items included. */
function navigationRoutes(layout: LayoutResponse | undefined): string[] {
  if (!layout) {
    return [];
  }
  const items = [
    ...layout.layout.sidebarSections.flatMap(section => section.items),
    ...layout.layout.headerItems,
    ...(layout.layout.headerConfig?.userDropdown?.items ?? []),
  ];
  return items
    .flatMap(item => [item.route, ...(item.children ?? []).map(child => child.route)])
    .filter((route): route is string => typeof route === 'string' && route.length > 1);
}

/** Is `pathname` a page (or below a page) the backend says this app has? */
export function isLegacyPath(pathname: string, layout: LayoutResponse | undefined): boolean {
  return navigationRoutes(layout).some(route => {
    const base = route.replace(/\/+$/, '');
    return pathname === base || pathname.startsWith(`${base}/`);
  });
}
